import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from '../../components/Card';
import { Pagination } from '../../components/Pagination';
import { Table } from '../../components/Table';
import { MomentFormat, utcToLocalFormat } from '../../plugins/moment';
import queryString from 'query-string';
import { Paged } from '../../types/common';
import { PopUpForm } from '../../types/popupForm';
import { getPopUpForms } from '../../api/popupFormAPI';
import { PopUpFormModal } from './PopUpFormModal';

export const PopUpFormListTable = () => {
  const history = useHistory();
  const query = queryString.parse(history.location.search);
  const [isViewModal, setIsViewModal] = useState(Boolean);
  const [popUpFormId, setPopUpFormId] = useState(Number);
  const [popUpForms, setPopUpForms] = React.useState<Paged<PopUpForm>>({
    items: [],
  });

  const getList = () => {
    let nQuery = ``;
    nQuery += `&order[id]=DESC`;
    getPopUpForms(`${nQuery}`, Number(query.page), Number(query.limit))
      .then((res) => setPopUpForms(res.data))
      .catch((err) => console.error(err.response));
  };

  useEffect(() => getList(), [history.location]);

  return (
    <>
      <Card>
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Th>문의 요청 일자</Table.Th>
              <Table.Th>회사명</Table.Th>
              <Table.Th>브랜드명</Table.Th>
              <Table.Th>담당자명</Table.Th>
              <Table.Th>담당자연락처</Table.Th>
              <Table.Th>담당자이메일</Table.Th>
              <Table.Th>희망지점</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {popUpForms.items.length === 0 && (
              <Table.Row>
                <Table.Td colSpan={8}>팝업 문의 요청이 없습니다.</Table.Td>
              </Table.Row>
            )}
            {popUpForms.items.map((popUpForm) => (
              <Table.Row key={popUpForm.id}>
                <Table.Td>
                  {utcToLocalFormat(
                    popUpForm.createdAt.toLocaleString(),
                    MomentFormat.YYYYMMDDHmm
                  )}
                </Table.Td>
                <Table.Td>{popUpForm.companyName}</Table.Td>
                <Table.Td>{popUpForm.brandName}</Table.Td>
                <Table.Td>{popUpForm.managerName}</Table.Td>
                <Table.Td>{popUpForm.managerPhoneNumber}</Table.Td>
                <Table.Td>{popUpForm.managerEmail}</Table.Td>
                <Table.Td>{popUpForm.desiredBranch}</Table.Td>
                <Table.Td>
                  <button
                    className="rounded-md font-normal text-indigo-600 hover:text-indigo-900"
                    onClick={() => {
                      setIsViewModal(true);
                      setPopUpFormId(popUpForm.id);
                    }}
                  >
                    상세보기
                  </button>
                </Table.Td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <Pagination>
          <Pagination.Label
            count={popUpForms.items.length}
            total={popUpForms.pagination?.totalItemCount!}
          />
          <Pagination.Nav
            basePath={history.location.pathname}
            total={popUpForms.pagination?.totalItemCount!}
          />
        </Pagination>
      </Card>
      <PopUpFormModal
        popUpFormId={popUpFormId}
        open={isViewModal}
        onClose={() => setIsViewModal(false)}
      />
    </>
  );
};
